import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-bank-reconciliations',
  templateUrl: './bank-reconciliations.component.html',
  styleUrls: ['./bank-reconciliations.component.css']
})
export class BankReconciliationsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3393))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_bankreconciliations_grid').setLoadDataFunction({ method: 3384, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
            case 'balance_date':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    balance_date: string;
}
